import { cloneDeep } from 'lodash'

import { AskResponse } from '../../api'

export type ParsedAnswer = {
  sources: string[]
  answerText: string,
  supportedFeatures: string[],
}
export function parseAnswer(answer: AskResponse): ParsedAnswer {
  return {
    sources: answer.sources,
    answerText: answer.answer,
    supportedFeatures:answer.supported_topics,
  }
}
